import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";

const AdminSettingsParty = ({ onBack }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [events, setEvents] = useState([]);

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);

  // Form states unutar modala
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [showTime, setShowTime] = useState(true);
  const [startTime, setStartTime] = useState("20:00");
  const [endTime, setEndTime] = useState("02:00");
  const [description, setDescription] = useState("");

  // Automatsko sortiranje događaja po datumu
  const sortEvents = (eventList) => {
    return [...eventList].sort((a, b) =>
      String(a.date).localeCompare(String(b.date)),
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await supabase
        .from("party_settings")
        .select("*")
        .eq("id", 1)
        .maybeSingle();

      if (data && !error) {
        setEvents(sortEvents(data.party_schedule || []));
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleAddNew = () => {
    setCurrentEvent(null);
    setTitle("");
    setDate("");
    setShowTime(true);
    setStartTime("20:00");
    setEndTime("02:00");
    setDescription("");
    setIsModalOpen(true);
  };

  const handleEditClick = (event) => {
    setCurrentEvent(event);
    setTitle(event.title || "");
    setDate(event.date || "");
    setShowTime(event.showTime !== undefined ? event.showTime : true);
    setStartTime(event.startTime || "20:00");
    setEndTime(event.endTime || "02:00");
    setDescription(event.description || "");
    setIsModalOpen(true);
  };

  const handleSaveEvent = (e) => {
    e.preventDefault();
    if (!title || !date) return alert("Naziv i datum su obavezni!");

    const eventData = {
      id: currentEvent ? currentEvent.id : Date.now(),
      title,
      date,
      showTime,
      startTime: showTime ? startTime : "",
      endTime: showTime ? endTime : "",
      description,
    };

    let updatedEvents;
    if (currentEvent) {
      updatedEvents = events.map((ev) =>
        ev.id === currentEvent.id ? eventData : ev,
      );
    } else {
      updatedEvents = [...events, eventData];
    }

    setEvents(sortEvents(updatedEvents));
    setIsModalOpen(false);
  };

  const handleDeleteEvent = () => {
    if (!currentEvent) return;
    if (
      window.confirm(
        `Jeste li sigurni da želite obrisati događaj "${currentEvent.title}"?`,
      )
    ) {
      const updatedEvents = events.filter((ev) => ev.id !== currentEvent.id);
      setEvents(sortEvents(updatedEvents));
      setIsModalOpen(false);
    }
  };

  const handleFinalDatabaseSave = async () => {
    setSaving(true);
    const { error } = await supabase.from("party_settings").upsert(
      {
        id: 1,
        party_schedule: events,
      },
      { onConflict: "id" },
    );

    if (!error) {
      alert("Uspješno spremljeno u bazu!");

      if (onBack) onBack();
    } else {
      alert(`Greška pri spremanju: ${error.message}`);
    }
    setSaving(false);
  };

  // Provjera je li događaj završio u odnosu na današnji datum
  const isEventPast = (eventDate) => {
    if (!eventDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const evDate = new Date(eventDate);
    evDate.setHours(0, 0, 0, 0);
    return evDate < today;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}.${month}.${year}.`;
  };

  if (loading) return <div className="admin-loader">Učitavam raspored...</div>;

  return (
    <div className="admin-party-edit">
      {" "}
      <button className="back-btn" onClick={onBack}>
        <i className="fi fi-rs-arrow-left"></i> Natrag
      </button>
      <div className="admin-header-flex">
        <h3>Program i Događaji</h3>
      </div>
      <div className="admin-form-container">
        <div className="action-bar">
          <button className="add-event-btn" onClick={handleAddNew}>
            + DODAJ NOVI DOGAĐAJ
          </button>
        </div>

        <div className="admin-events-grid">
          {events.length === 0 ? (
            <div className="no-events-notice">
              Trenutno nema dodanih događaja.
            </div>
          ) : (
            events.map((ev) => {
              const past = isEventPast(ev.date);
              return (
                <div
                  key={ev.id}
                  className={`admin-event-card ${past ? "event-past" : ""}`}
                  onClick={() => handleEditClick(ev)}
                >
                  {/* Tražena kvačica u gornjem desnom kutu s opacity 0.6 */}
                  {past && (
                    <div
                      className="past-corner-badge"
                      title="Događaj je završio"
                    >
                      <i className="fi fi-rs-circle-check"></i>
                    </div>
                  )}

                  {/* Središnji natpis preko ekrana koji se pojavi kad je završeno */}
                  {past && (
                    <div className="past-center-text">Događaj završio</div>
                  )}

                  <div className="event-card-inner">
                    <span className="event-card-date">
                      <i className="fi fi-rs-calendar"></i>{" "}
                      {formatDate(ev.date)}
                    </span>
                    <h4 className="event-card-title">{ev.title}</h4>

                    {ev.showTime && (
                      <span className="event-card-time">
                        <i className="fi fi-rs-clock"></i> {ev.startTime} -{" "}
                        {ev.endTime} h
                      </span>
                    )}

                    {ev.description && (
                      <p className="event-card-desc">{ev.description}</p>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>

        <button
          className="main-admin-btn save-btn"
          onClick={handleFinalDatabaseSave}
          disabled={saving}
        >
          {saving ? "SPREMANJE..." : "SPREMI SVE IZMJENE"}
        </button>
      </div>
      {/* MODAL ZA UNOS / UREĐIVANJE */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div
            className="event-admin-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>{currentEvent ? "Uredi Događaj" : "Dodaj Novi Događaj"}</h3>

            <form onSubmit={handleSaveEvent}>
              <div className="form-group">
                <label>Naziv događaja / Turnira</label>
                <input
                  type="text"
                  placeholder="npr. BELA TURNIR"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>Datum održavanja</label>
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                />
              </div>

              <div className="form-group toggle-group">
                <label className="toggle-label">
                  Prikaži vrijeme na kartici?
                </label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={showTime}
                    onChange={(e) => setShowTime(e.target.checked)}
                  />
                  <span className="slider"></span>
                </label>
              </div>

              {showTime && (
                <div className="form-row time-row">
                  <div className="form-group">
                    <label>Od</label>
                    <input
                      type="time"
                      value={startTime}
                      onChange={(e) => setStartTime(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Do</label>
                    <input
                      type="time"
                      value={endTime}
                      onChange={(e) => setEndTime(e.target.value)}
                    />
                  </div>
                </div>
              )}

              <div className="form-group">
                <label>Detalji / Opis programa</label>
                <textarea
                  placeholder="Dodatne informacije..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows="3"
                />
              </div>

              <div className="modal-actions-flex">
                <button type="submit" className="modal-btn save-evt-btn">
                  Spremi
                </button>
                {currentEvent && (
                  <button
                    type="button"
                    className="modal-btn delete-evt-btn"
                    onClick={handleDeleteEvent}
                  >
                    Obriši događaj
                  </button>
                )}
                <button
                  type="button"
                  className="modal-btn cancel-evt-btn"
                  onClick={() => setIsModalOpen(false)}
                >
                  Odustani
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSettingsParty;
